import { render, staticRenderFns } from "./PCapabilities.vue?vue&type=template&id=cdc067c8&"
import script from "./PCapabilities.vue?vue&type=script&lang=ts&"
export * from "./PCapabilities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports